
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ProductsFiltersProps {
  selectedType: string;
  selectedStock: string;
  types: string[];
  onTypeChange: (value: string) => void;
  onStockChange: (value: string) => void;
}

export function ProductsFilters({
  selectedType,
  selectedStock,
  types,
  onTypeChange,
  onStockChange,
}: ProductsFiltersProps) {
  return (
    <div className="flex flex-wrap gap-4 mb-6">
      <Select
        value={selectedType}
        onValueChange={onTypeChange}
      >
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Filtrar por tipo" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos os tipos</SelectItem>
          {types.map((type) => (
            <SelectItem key={type} value={type}>
              {type}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={selectedStock}
        onValueChange={onStockChange}
      >
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Filtrar por estoque" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todo estoque</SelectItem>
          <SelectItem value="out">Fora de estoque</SelectItem>
          <SelectItem value="low">Estoque baixo</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
